// extracted by mini-css-extract-plugin
module.exports = {"overlay":"ModalInfo_overlay__1gIGI","modal":"ModalInfo_modal__24iaG","header":"ModalInfo_header__2twhd","closeButton":"ModalInfo_closeButton__a0FPY","body":"ModalInfo_body__W3Cy3"};